import { NavLink } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import React from "react";
import useTranslation from "../../i18n/useTranslation";

export default function StripeOnboardSuccessPage() {
    const { t } = useTranslation();

    return (
        <div
            style={{
                backgroundColor: "#14151a",
                color: "#ffffff",
                fontFamily: "'Poppins', sans-serif",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflowX: "hidden",
            }}
        >
            <div
                style={{
                    backgroundColor: "#1f1f2e",
                    borderRadius: "12px",
                    padding: "30px",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
                    textAlign: "center",
                    maxWidth: "450px",
                    width: "100%",
                }}
            >
                <div className="mb-3">
                    <NavLink to="/">
                        <img
                            src="/dist/img/angeonx-sports.png"
                            alt={t("stripeOnboardSuccessPage.brandAlt")}
                            className="logo img-fluid"
                            style={{ height: "80px", marginBottom: "10px" }}
                        />
                    </NavLink>

                    <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "var(--kbs-primary, #00adff)" }}>
                        kBola <span style={{ color: "#ffffff" }}>Sports</span>
                    </h2>
                </div>

                <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {t("stripeOnboardSuccessPage.title")}
                </h3>

                <p>
                    <FaCheckCircle size={50} color="var(--kbs-primary, #00adff)" />
                </p>

                <p
                    style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#f1f2f5",
                    }}
                >
                    {t("stripeOnboardSuccessPage.message")}
                </p>
            </div>
        </div>
    );
}
